import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from '../../../../styles/dggTheme';

export const root = css`
  padding: ${pxToRem(dggTheme.spacing.md)};
  text-align: center;
`;

export const heading = css`
  margin: 0;
  font-family: ${dggTheme.fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  font-size: ${pxToRem(24)};
`;

export const copy = css`
  margin: 0;
  font-size: ${pxToRem(18)};
`;
